import classNames from 'classnames/bind';
import Checkbox from 'mcs-toolkit/components/Checkbox';
import React from 'react';
import { StrictCheckboxProps } from 'semantic-ui-react';

import { QuestionTooltip } from 'reactApp/components/questionTooltip/questionTooltip';

import styles from './CheckboxAdvanced.css';

const css = classNames.bind(styles);

const _getHint = (text) => (
    <div className={css('hint')}>
        <QuestionTooltip text={text} position="right center" />
    </div>
);

export type CheckboxAdvancedProps = {
    description?: React.ReactNode;
    dataTest?: string;
    bold?: boolean;
    fullWidth?: boolean;
} & StrictCheckboxProps;

export const CheckboxAdvanced = ({
    description,
    className,
    dataTest = 'checkbox-advanced',
    bold = false,
    fullWidth = false,
    ...otherProps
}: CheckboxAdvancedProps) => (
    <div className={css('root', className)}>
        <Checkbox
            data-test={dataTest}
            {...otherProps}
            className={css({
                bold,
                fullWidth,
            })}
        />
        {description && _getHint(description)}
    </div>
);
